module.exports = __webpack_public_path__ + "img/norway-cerebrovascular-disease-male.560830b0.png";